import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfAuthorBasicInfo } from './getExploreContent200PageAllOfThreeContentItemContentOneOfAuthorBasicInfo';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfAuthorSocial } from './getExploreContent200PageAllOfThreeContentItemContentOneOfAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: GetExploreContent200PageAllOfThreeContentItemContentOneOfAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetExploreContent200PageAllOfThreeContentItemContentOneOfAuthorSocial;
};
